// import 
import React, { useEffect } from "react";
import WhitePlusfor from "./WhitePlusfor"
import WashPress from "./PressWash";
import { Container, Row, Col, Navbar, Nav, Button, Card, Badge, ListGroup } from 'react-bootstrap';

import "../PressOnly/PressOnly.css";

import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
const pressImg =
  "/white.jpg";
export default function WhitePlus() {
    const navigate = useNavigate();
  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <div>
      <section className="pressonly-wrap">

        <section className="hero-section-freash-clean  pt-5 mt-5 position-relative overflow-hidden">
          <div className="hero-overlay-freash-clean py-5">
            <Container fluid="xl" className="py-5 mt-4 h-100">
              <Row className="align-items-center justify-content-center text-center h-100">
                <Col lg={8}>
                  <h1 className="hero-title mb-4">
                    WhitePlus  <br />


                  </h1>
                  <p style={{ color: "white", textAlign: "center", fontSize: "17px" }}>

                    The exclusive White+ treatment is chlorine-free and treats efficiently your delicate garments while preserving their natural qualities, making them fresher and brighter
                    <br />
                    White+ is essential to revive the white of textiles that have gone gray or yellow.

                    White clothes and linens easily get dirty and their fiber can quickly be damaged by some whitening treatments. Our White+ treatment has a bleaching effect without using chlorine.
                    It revives the white of your clothes that are affected by grey and yellow tones and emphasizes the clean and crisp effect of your already white garmen
                  </p>
                <div className="d-flex justify-content-center flex-wrap gap-3 mt-4">
                               <button className="suhedule-btn-dark"
                               
                                onClick={() =>
                 window.open(
                   "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
                   "_blank"
                 )
               }>
                               Book Now
                               </button>
                   
                               <button className="view-prices-list"  onClick={() => navigate("/laundry-price")}>
                                 VIEW PRICE LIST
                               </button>
                             </div>
                </Col>
              </Row>
            </Container>
          </div>
        </section>

      </section>
      <div data-aos="fade-up">
        <WhitePlusfor />
      </div>
      <WashPress />
    </div>

  );
}
